/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hd--notifications[_ngcontent-%COMP%]{position:fixed;z-index:200;left:10%;right:10%;top:12rem}.hd--standard-page[_ngcontent-%COMP%]{padding-top:10rem;height:100%}.hd--standard-page.xs[_ngcontent-%COMP%]{padding-top:56px}.version-number[_ngcontent-%COMP%]{margin-top:5px;font-size:10px;color:#d4d4d4;float:right}.version-number[_ngcontent-%COMP%]::-moz-selection{background:#505050}.version-number[_ngcontent-%COMP%]::selection{background:#505050}"];
export { styles as styles };
